import { toQueryString } from "@/react/helpers/urlHelpers";

export const authenticationAppRoutes = {
  discoverSignIn: ({ params = {} } = {}) =>
    `/user/sign_in?${toQueryString(params)}`,
  discoverSignUp: ({ params = {} } = {}) =>
    `/user/sign_up?${toQueryString(params)}`,
  discoverForgotPassword: () => `/user/password`,
  forgotPassword: ({ params = {} } = {}) =>
    `/users/password/new?${toQueryString(params)}`,
  signIn: ({ params = {} } = {}) => `/sign_in?${toQueryString(params)}`,
  socialSignIn: (method: string, community_id: number) =>
    `/users/auth/${method}?community_id=${community_id}`,
  signUp: ({ params = {} } = {}) => `/sign_up?${toQueryString(params)}`,
  terms: () => "/terms",
  privacy_policy: () => "/privacy",
  resetPassword: () => "/users/password",
  optSessions: () => "/auth/otp_sessions",
  resetPasswordOnOtpLogin: () => "/auth/password_reset",
  resendOtp: () => "/auth/otp_sessions/resend",
  two_fa: {
    emailOtpVerification: () => "/two_fa/email_otp/verify",
    emailOtpResend: () => "/two_fa/email_otp/resend",
  },
  communities: {
    new: () => "/communities/new",
    index: () => "/communities",
    update: (community_id: number) => `/communities/${community_id}`,
  },
};
